import loadable from '@loadable/component';
import pMinDelay from 'p-min-delay';

// Lazy load component
/* eslint-disable @typescript-eslint/no-explicit-any */
export const lazy = (cb: () => Promise<any>, fallback: JSX.Element): JSX.Element =>
  loadable(() => pMinDelay(cb(), 300), { fallback });
